import { useCallback, useMemo } from 'react';
import { useAppState, useAppDispatch } from '../../context/appState'; //

export const useModalActions = <T = Record<string, string>,>(
  key?: string,
): {
  requestModalClose: () => void;
  openModal: (data?: any) => void;
  isOpen: boolean;
  modalData: T; // Added undefined as a safety measure
} => {
  const state = useAppState(); // Subscribes to state changes
  const dispatch = useAppDispatch(); // Does NOT subscribe to state changes

  const requestModalClose = useCallback(() => {
    dispatch({ type: 'REQUEST_MODAL_CLOSE' });
  }, [dispatch]);

  const openModal = useCallback(
    (data: any = undefined) => {
      if (state.modal !== key) {
        dispatch({
          type: 'OPEN_MODAL',
          modal: key!,
          modalData: data,
        });
      }
    },
    [state.modal, key, dispatch],
  );

  const isOpen = useMemo(
    () => state.modal === key || !!state?.modalData,
    [state.modal, key],
  );

  return {
    requestModalClose,
    openModal,
    isOpen,
    modalData: state.modalData as T,
  };
};
